var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=visibility"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.0993652,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility",
    d: "M12.0994 16C13.3494 16 14.4119 15.5625 15.2869 14.6875C16.1619 13.8125 16.5994 12.75 16.5994 11.5C16.5994 10.25 16.1619 9.1875 15.2869 8.3125C14.4119 7.4375 13.3494 7 12.0994 7C10.8494 7 9.78687 7.4375 8.91187 8.3125C8.03687 9.1875 7.59937 10.25 7.59937 11.5C7.59937 12.75 8.03687 13.8125 8.91187 14.6875C9.78687 15.5625 10.8494 16 12.0994 16ZM12.0994 14.2C11.3494 14.2 10.7119 13.9375 10.1869 13.4125C9.66187 12.8875 9.39937 12.25 9.39937 11.5C9.39937 10.75 9.66187 10.1125 10.1869 9.5875C10.7119 9.0625 11.3494 8.8 12.0994 8.8C12.8494 8.8 13.4869 9.0625 14.0119 9.5875C14.5369 10.1125 14.7994 10.75 14.7994 11.5C14.7994 12.25 14.5369 12.8875 14.0119 13.4125C13.4869 13.9375 12.8494 14.2 12.0994 14.2ZM12.0994 19C9.66603 19 7.44937 18.3208 5.44937 16.9625C3.44937 15.6042 1.99937 13.7833 1.09937 11.5C1.99937 9.21667 3.44937 7.39583 5.44937 6.0375C7.44937 4.67917 9.66603 4 12.0994 4C14.5327 4 16.7494 4.67917 18.7494 6.0375C20.7494 7.39583 22.1994 9.21667 23.0994 11.5C22.1994 13.7833 20.7494 15.6042 18.7494 16.9625C16.7494 18.3208 14.5327 19 12.0994 19ZM12.0994 17C13.9827 17 15.7119 16.5042 17.2869 15.5125C18.8619 14.5208 20.066 13.1833 20.8994 11.5C20.066 9.81667 18.8619 8.47917 17.2869 7.4875C15.7119 6.49583 13.9827 6 12.0994 6C10.216 6 8.48687 6.49583 6.91187 7.4875C5.33687 8.47917 4.1327 9.81667 3.29937 11.5C4.1327 13.1833 5.33687 14.5208 6.91187 15.5125C8.48687 16.5042 10.216 17 12.0994 17Z",
    fill: "#1C1D1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOpen);
export default __webpack_public_path__ + "static/media/PasswordOpen.4b997fd9f622a960909dc65812503502.svg";
export { ForwardRef as ReactComponent };